import React, { useState } from "react";

interface LnUrlProps {
    lnurl: string;
    className?: string;
}

const LnUrl: React.FC<LnUrlProps> = ({ lnurl, className }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            // Add a subtle animation class when copying
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div>
            <div 
                className={`flex items-center gap-2 cursor-pointer ${className || ''} ${copied ? 'invisible h-[1px]' : ''}`}
                onClick={() => !copied && handleCopy(lnurl)}
            >
                <span className="break-words [word-break:break-word]">
                    {lnurl}
                </span>
                <i 
                    className="material-icons text-[18px]"
                    title="Copy to clipboard"
                >
                    file_copy
                </i>
            </div>
            <div className={`flex items-center gap-2 ${className || ''} ${!copied ? 'invisible h-[1px]' : ''}`}>
                <span className="break-words [word-break:break-word]">
                    Copied to clipboard
                </span>
                <i 
                    className="material-icons text-[18px]"
                >
                    check
                </i>
            </div>
        </div>
    );
}

export default LnUrl;